import type { SalesforceConsultationDate } from '@/store/consultationStore';
import { dfetch } from '@/utils/fetchUtils';

export const getAppointmentsForEmployee = (): Promise<SalesforceConsultationDate[]> => {
	return dfetch('/salesforce/events/me');
};
